import React from 'react';
import { resolveStyle, StyleSheet } from './style_sheet';

const styles = StyleSheet.create({
  scrollerStyle: {
    overflowX: 'hidden',
    overflowY: 'scroll',
    overflowScroll: 'contain',
  },
  scrollerStyleHorizontal: {
    overflowX: 'scroll',
    overflowY: 'hidden',
    overflowScroll: 'contain',
  },
  contentContainerStyle: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
  pointerBoxNone: {
    pointerEvents: 'none',
  },
});

export class View extends React.PureComponent<any> {
  render() {
    const {
      style: _,
      children,
      className: extraClass,
      pointerEvents,
      getDiv,
      ...other_props
    } = this.props;
    let style = this.props.style;
    if (pointerEvents === 'box-none' || pointerEvents === 'none') {
      style = [style, styles.pointerBoxNone];
    }

    const { inlineStyle, className } = resolveStyle(style, extraClass);

    const extra_props: any = {};
    if (getDiv) {
      extra_props.ref = getDiv;
    }

    return (
      <div
        className={className}
        style={inlineStyle}
        {...other_props}
        {...extra_props}
      >
        {children}
      </div>
    );
  }
}

export class ScrollView extends React.PureComponent<any> {
  _scrollRef: any = null;
  addScrollTop(delta: number | string) {
    if (this._scrollRef) {
      this._scrollRef.scrollTop += delta;
    }
  }
  setScrollTop(value: number | string) {
    if (this._scrollRef) {
      this._scrollRef.scrollTop = value;
      return this._scrollRef.scrollTop;
    }
  }
  _onScrollRef = (ref: any) => {
    this._scrollRef = ref;
  };

  render() {
    const {
      style,
      contentContainerStyle,
      horizontal,
      children,
      onScroll,
      ...other_props
    } = this.props;
    const base_style = horizontal
      ? styles.scrollerStyleHorizontal
      : styles.scrollerStyle;
    return (
      <View
        getDiv={this._onScrollRef}
        style={[base_style, style]}
        {...other_props}
      >
        <View
          style={[styles.contentContainerStyle, contentContainerStyle]}
          onScroll={onScroll}
        >
          {children}
        </View>
      </View>
    );
  }
}
